import { render } from "./ExpertStatisticsTemplate.vue?vue&type=template&id=b8b04a2e"
import script from "./ExpertStatisticsTemplate.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__